// General Indexes
export enum GeneralIndex {
  client = 0,
  sa = 2,
  mpi = 3,
}
// All column indexes
export enum AcIndex {
  ppc = 2,
  units = 3,
  trx = 4,
  percentage = 5,
  sa = 6,
  mpi = 7,
}
// Limited column indexes
export enum LcIndex {
  ppc = 1,
  sa,
  mpi,
}
// Final Quarter indexes
export enum FQIndex {
  patient = 1,
  unit = 2,
  livesToUnits = 4,
  scalingFactor = 5,
  unitToTrx = 6,
}
// user defined indexes
export enum UDIndex {
  ppc = 1,
  ppp = 1,
}
// baseline limited column indexes
export enum baselineLCIndex {
  trxShare = 2,
}
